import {css} from 'lit';

export default css`
  :host {
    --border-radius: 4px;
    display: block;
    padding-bottom: 25px;
  }

  ::selection {
    background: var(--brand);
    color: var(--brand-text);
  }

  a {
    color: var(--system-hyperlink);
    margin: 0;
    padding: 0;
    text-decoration: none;
    list-style: none;
    font-style: normal;
    -webkit-text-size-adjust: none;
  }

  .dialog__success {
    min-height: 500px;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .dialog__success .logo {
    position: relative;
    width: 80px;
    height: 80px;
    border-radius: 100%;
    margin-top: 50px;
    background: #cfeac0;
  }

  .dialog__success .logo:before {
    content: "";
    position: absolute;
    top: calc(50% - 24px);
    left: calc(50% - 10px);
    width: 17px;
    height: 32px;
    border-right: 6px solid var(--notification-success);
    border-bottom: 6px solid var(--notification-success);
    transform: rotate(40deg);
  }

  .dialog__success .heading {
    font-family: var(--font-family-sans-serif);
    font-size: 18px;
    font-style: normal;
    font-weight: 700;
    line-height: 22px;
    letter-spacing: 0;
    text-align: center;
    margin-bottom: 0;
  }

  .dialog__success .sub-heading {
    font-size: 16px;
    line-height: 22px;
    letter-spacing: 0;
    text-align: center;
    margin-top: 10px;
    max-width: 560px;
  }

  .dialog__button-wrapper {
    display: flex;
    justify-content: flex-end;
  }

  .btn-group {
    display: flex;
    flex-wrap: wrap;
    padding: 5px 0 5px;
    gap: 10px;
    margin-bottom: 20px;
  }

  .btn-group input[type="radio"] {
    position: absolute;
    opacity: 0;
  }

  .btn-group input[type="radio"]:checked + .btn {
    color: var(--white);
    background: var(--button-secondary-default-background);
  }

  .btn-group + .dialog__error {
    display: none;
    margin-bottom: 20px;
  }

  .btn-group.error {
    margin-bottom: 0;
  }

  .btn-group.error + .dialog__error {
    display: block;
  }

  // Dialog

  .dialog__wrapper {
    position: relative;
    width: 900px;
    padding: 10px;
    border: 1px solid var(--separator-default);
  }

  .dialog__title {
    /* Headline/Headline L */
    font-family: var(--font-family-sans-serif);
    border-bottom: 1px solid var(--separator-default);
    color: var(--text-highVisibility);
    font-style: normal;
    font-weight: bold;
    font-size: 22px;
    line-height: 26px;
    padding-bottom: 10px;
    margin: 0 0 20px;
  }


  .dialog__description {
    font-family: var(--font-family-sans-serif);
    color: var(--text-lowVisibility);
    font-size: 16px;
    line-height: 22px;
    margin-bottom: 20px;
  }

  .dialog__error {
    color: var(--notification-error);
    font-size: 14px;
    line-height: 20px;
  }


  .btn {
    font-size: 16px;
    font-weight: bold;
    text-align: center;
    line-height: 19px;
    border: 1px solid;
    box-sizing: border-box;
    border-radius: 4px;
    padding: 10px 16px;
    cursor: pointer;
  }

  .secondary {
    color: var(--button-secondary-default-background);
    border-color: var(--button-secondary-default-background);
  }

  .btn.secondary:hover,
  .btn.secondary:focus {
    background: var(--button-secondary-hover-background);
    color: var(--button-secondary-hover-label);
  }

  .primary {
    color: var(--button-primary-default-label);
    background: var(--button-primary-default-background);
    border-color: var(--button-primary-default-background);
  }

  .btn.primary:hover,
  .btn.primary:focus {
    background: var(--button-primary-hover-background);
    border-color: var(--button-primary-hover-background);
  }

  .form-group {
    display: flex;
    flex-wrap: wrap
  }

  .form-group.right {
    justify-content: flex-end;
  }

  .form-group.left {
    justify-content: flex-start;
  }

  .form-group .form-label {
    flex: 1 1 100%;
  }

  .form-group .form-control {
    flex: 1 1 100%;
    margin-bottom: 20px;
  }

  .form-group .dialog__error {
    flex: 1 1 85%;
  }

  .form-group div.word-count {
    text-align: right;
    font-size: 14px;
    line-height: 20px;
    color: var(--text-lowVisibility);
    flex: 1 1 15%;
  }

  .form-group button {
    grid-column: 12;
  }

  .form-group .btn-group {
    flex: 1 1 100%
  }

  .form-label {
    font-family: var(--font-family-sans-serif);
    font-weight: bold;
    font-size: 14px;
    color: var(--text-highVisibility);
    line-height: 16px;
    margin-bottom: 5px;
  }

  .form-control {
    padding: 10px;
    color: var(--text-highVisibility);
    background: var(--form-default-background);
    font-family: var(--font-family-sans-serif);
    font-size: 1.6rem;
    border: 1px solid var(--form-element-default-border);
    box-sizing: border-box;
    border-radius: 4px;
    line-height: 30px;
    width: 100%;
    margin-bottom: 5px;
  }

  .form-control:focus,
  .form-control:hover {
    border: 1px solid var(--button-secondary-default-background);
  }

  .form-control:focus-visible {
    outline: none;
  }

  .form-control.error {
    margin-bottom: 5px;
  }

  .form-control.error,
  .form-control.error:focus,
  .form-control.error:hover {
    border: 1px solid var(--notification-error);
  }

  input[type="checkbox"].form-control.error {
    border: 1px solid var(--notification-error);
    appearance: none;
  }

  .form-control + .dialog__error,
  .form-control ~ .dialog__error {
    display: none;
  }

  .form-control.error + .dialog__error,
  .form-control.error ~ .dialog__error {
    display: block;
    margin-bottom: 20px;
  }

  .form-group .accept {
    position: relative;
    width: 40px;
    height: 40px;
    margin: 0;
    flex: initial;
  }

  .form-group .dialog__hint {
    flex: 1;
    justify-self: center;
  }

  .dialog__usercontent.dialog__message {
    height: 131px;
    margin-bottom: 5px;
    line-height: 20px;
  }

  .dialog__input {
    height: 40px;
  }

  .form-label.dialog__hint {
    margin-left: 10px;
    color: var(--text-lowVisibility);
    line-height: 20px;
    font-weight: normal !important;
  }

  .custom-checkbox {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    border: 1px solid var(--buttonTertiary-default-border);
    cursor: pointer;
  }

  .custom-checkbox:checked:after {
    content: "";
    position: absolute;
    width: 10px;
    height: 20px;
    top: 5px;
    left: 12px;
    transform: rotate(38deg);
    border-right: 5px solid var(--button-secondary-default-background);
    border-bottom: 5px solid var(--button-secondary-default-background);
    transition: all;

    // use --button-secondary because the color mapping exists and already works
  }

  div.word-count.error {
    color: var(--notification-error);
  }

  .required {
    color: var(--text-lowVisibility); // color: #999999;
    font-size: 14px;
    margin-bottom: 10px;
  }

  .responseError {
    padding: 32px 36.4px 32px 33px;
    display: flex;
    margin-top: 25px;
    box-sizing: border-box;
    background: var(--error-bg);
    opacity: 1;
    animation: 0.3s ease-in 0s 1 normal none running showElement;
    font-size: 1.6rem;
    line-height: 2.4rem;
    min-width: 100%;
    align-items: center;
  }

  .responseError .error-hint {
    margin-left: 33px;
    flex: 1;
  }

  @keyframes showElement {
    0% {
      display: none;
      opacity: 0;
    }
    1% {
      display: flex;
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }

  .icon-warning {
    width: 20px;
    height: 44px;
    display: inline-block;
    background-repeat: no-repeat;
    background-size: 20px 44px;
    background-image: url("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iNzgiIHZpZXdCb3g9IjAgMCAyMCA3OCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMi45MjQgNTUuMjU0OUMxMS45NjkzIDU1LjY5ODIgMTAuOTM0NiA1NS45NDMzIDkuODgyNTYgNTUuOTc1M0M4LjgzMjcgNTUuOTM5OSA3LjgwMDg3IDU1LjY5MjMgNi44NDkyNiA1NS4yNDc0QzUuODk3NjUgNTQuODAyNiA1LjA0NTk1IDU0LjE2OTcgNC4zNDU1MSA1My4zODY4QzMuNjQ1MDcgNTIuNjA0IDMuMTEwMzkgNTEuNjg3NCAyLjc3MzY4IDUwLjY5MjRDMi40MzY5NyA0OS42OTczIDIuMzA1MjEgNDguNjQ0NCAyLjM4NjM0IDQ3LjU5NzFMMCA4LjQzMDAxQzAgMy43ODcwMiA1LjIzOTU3IDAgOS44ODI1NiAwQzE0LjUyNTYgMCAyMC4xMDIzIDMuNzM1MTQgMTkuOTk4NiA4LjM3ODEzTDE3LjQwNDcgNDcuNTk3MUMxNy40ODU5IDQ4LjY0NjYgMTcuMzUzMyA0OS43MDE1IDE3LjAxNSA1MC42OTgzQzE2LjY3NjggNTEuNjk1IDE2LjEzOTggNTIuNjEyNyAxNS40MzY2IDUzLjM5NTlDMTQuNzMzNCA1NC4xNzkxIDEzLjg3ODYgNTQuODExNiAxMi45MjQgNTUuMjU0OVpNMTguMjM0OCA2OS41NDExQzE4LjIzNDggNzQuMTEwOSAxNC41MzAyIDc3LjgxNTQgOS45NjAzOCA3Ny44MTU0QzUuMzkwNTcgNzcuODE1NCAxLjY4NjAxIDc0LjExMDkgMS42ODYwMSA2OS41NDExQzEuNjg2MDEgNjQuOTcxMyA1LjM5MDU3IDYxLjI2NjcgOS45NjAzOCA2MS4yNjY3QzE0LjUzMDIgNjEuMjY2NyAxOC4yMzQ4IDY0Ljk3MTMgMTguMjM0OCA2OS41NDExWiIgZmlsbD0iI2Q0MDAwMCIvPgo8L3N2Zz4K");
  }

  .form-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-column-gap: 2rem;
  }
`;
